import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Track page views on route change
export const usePageviewTracker = () => {
  const location = useLocation();
  const prevPath = useRef(null);

  useEffect(() => {
    if (location.pathname === prevPath.current) return;
    prevPath.current = location.pathname;

    axios.post(`${API}/analytics/pageview`, {
      page: location.pathname,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent,
    }).catch(() => {}); // fire-and-forget
  }, [location.pathname]);
};

// Track click events — call this in onClick handlers
export const trackEvent = (element, page) => {
  axios.post(`${API}/analytics/event`, {
    event_type: 'click',
    element,
    page,
  }).catch(() => {}); // fire-and-forget
};
